import React from 'react';
import { useSearchkit } from '@searchkit/client';
import Button from '../../Button';
var SearchLoadMore = function SearchLoadMore(_ref) {
  var data = _ref.data,
    label = _ref.label,
    className = _ref.className;
  var api = useSearchkit();
  if (!data) {
    return null;
  }
  var setNextPage = function setNextPage() {
    if (data) {
      api.setPage({
        size: data.results.hits.page.size,
        from: parseInt(data.results.hits.page.size) * (parseInt(data.results.hits.page.pageNumber) + 1)
      });
      api.search();
    }
  };
  var currentPage = data.results.hits.page.pageNumber;
  var lastPage = data.results.hits.page.totalPages;
  if (currentPage + 1 >= lastPage) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: setNextPage
  }, label));
};
export default SearchLoadMore;